import { useFormContext } from 'react-hook-form'
import { LeaveRequestCreateSchema } from '../../../../../database/validations/LeaveRequestCreate'

export default function useLeaveRequestFormInputsViewModel() {
  const formHook = useFormContext<LeaveRequestCreateSchema>()

  return { formHook }
}
